module.exports = __webpack_public_path__ + "static/media/responsive-design.d4791f89.svg";